export const MainContentLoadingStatus = {
	LOADING: 'loading',
	LOADED: 'loaded'
};

export const SITE_CODES = {
	COMEON: 'comeon',
	PZBUK: 'pzbuk',
	FOLKEAUTOMATEN: 'folkeautomaten',
	MOBILEBET: 'mobilebet',
	MOBILAUTOMATEN: 'mobilautomaten',
	GETLUCKY: 'getlucky',
	NORGESSPILL: 'norgesspill',
	CHERRYCASINO: 'cherrycasino'
};

export const SessionStorageKeys = {
	DEPOSIT_LIMITS_SUGGESTIONS_KEY: 'depositLimitSuggestions',
	ENABLE_LC3_FEATURE: 'enableLC3Feature'
};
